// Deutsch — Deutschland
export default {
  translation: {
    app_name: 'Agora',
    tagline: 'Wo Hobbys Gemeinschaften aufbauen',
    nav_explore: 'Entdecken',
    nav_find_folks: 'Leute finden',
    nav_sign_in: 'Anmelden',
    nav_join_free: 'Kostenlos beitreten',
    nav_sign_out: 'Abmelden',
    nav_my_profile: 'Mein Profil',
    nav_notifications: 'Benachrichtigungen',
    auth_register: 'Konto erstellen',
    auth_login: 'Anmelden',
    auth_name: 'Vollständiger Name',
    auth_email: 'E-Mail-Adresse',
    auth_password: 'Passwort',
    auth_age: 'Dein Alter',
    auth_city: 'Stadt',
    auth_building: 'Gebäude / Wohnanlage',
    auth_country: 'Land',
    auth_currency: 'Währung',
    auth_locale: 'Sprache und Region',
    auth_already_have_account: 'Bereits registriert?',
    auth_no_account: 'Noch kein Konto?',
    postcode_label: 'Postleitzahl',
    postcode_placeholder: 'z.B. 10115',
    profile_edit: 'Profil bearbeiten',
    profile_bio: 'Über mich',
    profile_interests: 'Interessen',
    profile_location: 'Standort',
    profile_theme: 'Anzeigedesign',
    profile_currency_settings: 'Währung und Region',
    profile_save: 'Änderungen speichern',
    profile_cancel: 'Abbrechen',
    group_join: 'Gruppe beitreten',
    group_leave: 'Gruppe verlassen',
    group_members: 'Mitglieder',
    group_chat: 'Chat',
    group_events: 'Veranstaltungen',
    group_shop: 'Shop',
    group_campaigns: 'Kampagnen',
    group_about: 'Info',
    group_full: 'Voll',
    group_open: 'Offen',
    tip_send: 'Trinkgeld senden',
    tip_amount: 'Betrag',
    tip_message: 'Nachricht (optional)',
    wallet_coins: 'Münzen',
    wallet_balance: 'Guthaben',
    tips_earned: 'verdient',
    event_register: 'Anmelden',
    event_unregister: 'Abmelden',
    event_ticket_price: 'Ticket',
    event_free: 'Kostenlos',
    event_capacity: 'Kapazität',
    event_registered: 'angemeldet',
    no_results: 'Keine Ergebnisse gefunden',
    loading: 'Laden…',
    error_generic: 'Etwas ist schiefgelaufen. Bitte versuche es erneut.',
  }
};
